import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { HelpCircle } from "lucide-react";
import api from '../../service/api';
import { proximaEtapa, textoProximaEtapa } from '../../data/fluxoAvaliacao';
import '../../css/Anamnese.css';
import '../../css/style.css';
import ImagensSilhuetas from '../../images/anamneseMulhersCorpos.png';

// Dados das perguntas
const PERGUNTAS = [
    { id: 0, texto: "1. Quais os seus objetivos com o programa de treinamento?", tipo: "checkbox", temOutros: true },
    { id: 1, texto: "2. Como você classificaria sua autoestima hoje?", tipo: "radio" },
    { id: 2, texto: "3. Daqui a 6 meses, quais objetivos conquistados te deixariam mais feliz?", tipo: "checkbox", temOutros: true },
    { id: 3, texto: "4A. Qual silhueta melhor representa sua aparência física atual?", tipo: "radio", imagem: ImagensSilhuetas },
    { id: 4, texto: "4B. Qual silhueta você gostaria de ter (ideal)?", tipo: "radio" },
    { id: 5, texto: "5. Você já fez uso de remédios para emagrecer? (Se sim, especifique nomes e resultados)", tipo: "text", placeholder: "Ex: Não / Sim, usei X com resultado Y" },
    { id: 6, texto: "6. Qual é a sua maior dificuldade para conseguir emagrecer?", tipo: "checkbox", temOutros: true },
    { id: 7, texto: "7. Nos últimos 6 meses, o ciclo menstrual esteve regulado?", tipo: "radio" },
    { id: 8, texto: "8. Durante o período menstrual, quais sintomas você costuma sentir?", tipo: "checkbox", temOutros: true },
    { id: 9, texto: "9. Nos últimos 6 meses, você fez uso de anticoncepcional?", tipo: "radio" },
    { id: 10, texto: "10. Você tem alguma das condições abaixo?", tipo: "checkbox" },
    { id: 11, texto: "11. Praticou exercício nos últimos 6 meses? Se sim, qual?", tipo: "text", placeholder: "Ex: Musculação, 3x na semana, moderada" },
    { id: 12, texto: "12. Quais fatores te impedem de manter a regularidade nos treinos?", tipo: "checkbox" },
    { id: 13, texto: "13. Qual sua disponibilidade (Dias na semana e minutos por dia)?", tipo: "text", placeholder: "Ex: 4 dias, 60 min" },
    { id: 14, texto: "14. Quais tipos de exercícios você GOSTA de fazer?", tipo: "checkbox", temOutros: true },
    { id: 15, texto: "15. Quais tipos de exercícios você NÃO GOSTA de fazer?", tipo: "checkbox", temOutros: true },
    { id: 16, texto: "16. Faz uso de algum remédio de forma crônica (todo dia)?", tipo: "text", placeholder: "Não / Sim, especifique os nomes" },
    { id: 17, texto: "17. Teve dor em alguma região nos últimos 7 dias? (Informe a região e nota de 0 a 10)", tipo: "text", placeholder: "Ex: Lombar - nota 7" },
    { id: 18, texto: "18. Algo relevante sobre sua saúde ou rotina para o programa de exercícios?", tipo: "text", placeholder: "Descreva aqui..." }
];

const OPCOES_RESPOSTAS = [
    { id: 0, opcoes: ["Prevenção de doenças", "Condicionamento Físico", "Emagrecimento", "Ganho de massa muscular (corpo inteiro)", "Controlar doenças", "Diminuir dores corporais", "Ganho de massa muscular (quadril e coxas)"] },
    { id: 1, opcoes: ["Muito Baixa", "Baixa", "Média", "Alta", "Muito Alta"] },
    { id: 2, opcoes: ["Conseguir emagrecer", "Conseguir tonificar a musculatura", "Ganhar massa no quadril e coxas", "Sentir mais disposição", "Ter mais energia", "Sentir-se bem consigo mesma", "Viver sem dor"] },
    { id: 3, opcoes: ["1", "2", "3", "4", "5", "6", "7", "8", "9"] },
    { id: 4, opcoes: ["1", "2", "3", "4", "5", "6", "7", "8", "9"] },
    { id: 5, opcoes: [] },
    { id: 6, opcoes: ["Manter a regularidade nos exercícios", "Manter a regularidade na dieta", "Manter o ânimo para treinar", "Desconto a tristeza na comida", "Falto aos treinos quando estou triste"] },
    { id: 7, opcoes: ["Sim", "Não, irregular no último mês", "Não, irregular nos últimos 3 meses", "Não, irregular nos últimos 6 meses", "Não, ciclo suspenso (+3 meses)"] },
    { id: 8, opcoes: ["Nenhum", "Tontura", "Moleza", "Dor abdominal", "Dor na coluna lombar", "Dor nas pernas", "Irritação", "Tristeza", "Queda de pressão", "Visão escurecida", "Formigamento", "Palpitação", "Sono excessivo"] },
    { id: 9, opcoes: ["Sim", "Não"] },
    { id: 10, opcoes: ["Diabetes tipo 1", "Diabetes tipo 2", "Hipertensão arterial", "Colesterol elevado", "Glicose elevada", "Ovário policístico", "Asma", "Câncer", "Artrite", "Artrose", "Osteoporose", "Nenhuma"] },
    { id: 11, opcoes: [] },
    { id: 12, opcoes: ["Falta de tempo", "Falta de motivação", "Falta de energia", "Falta de conhecimento", "Não gosto de exercícios vigorosos", "Não gosto de suar", "Dores durante o exercício", "Dores após o exercício", "Experiências negativas anteriores", "Medo de se machucar", "Não gosto de treinar sozinha"] },
    { id: 13, opcoes: [] },
    { id: 14, opcoes: ["Musculação", "Peso do corpo", "Funcional", "Circuitado", "Esteira", "Bike", "Transport", "Natação", "Lutas"] },
    { id: 15, opcoes: ["Musculação", "Peso do corpo", "Funcional", "Circuitado", "Esteira", "Bike", "Transport", "Natação", "Lutas"] },
    { id: 16, opcoes: [] },
    { id: 17, opcoes: [] },
    { id: 18, opcoes: [] }
];

function AnamneseMulheresEmagrecimento({ setPerfilAnamnese, setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {

    // Navegação entre etapas
    const [etapa, setEtapa] = useState(1);
    const totalEtapas = 4;
    const porcentagemConclusao = (etapa / totalEtapas) * 100;

    const avancarEtapa = () => {
        setEtapa(etapa + 1);
    };

    const retrocederEtapa = () => {
        if (etapa > 1) {
            setEtapa(etapa - 1);
        }
    };

    // Modal para próxima etapa
    const [isNextModal, setIsNextModal] = useState(false);
    const openNextModal = () => {
        console.log(respostasSelecionadas);
        setIsNextModal(true);
    };
    const closeNextModal = () => {
        setIsNextModal(false);
    };

    // Popup de informações
    const [showInfo, setShowInfo] = useState(false);

    // Modal para selecionar a anamnese
    const [isAnamneseTypeModal, setIsAnamneseTypeModal] = useState(false);
    const openAnamneseTypeModal = () => {
        setIsAnamneseTypeModal(true);
    };
    const closeAnamneseTypeModal = () => {
        setIsAnamneseTypeModal(false);
    };

    const [isChoosingAnamnese, setIsChoosingAnamnese] = useState(false);
    const handleChooseAnamnese = () => {
        setIsChoosingAnamnese(true);
    };

    // SALVAR E BUSCAR NO BD - LEVI
    const [respostasSelecionadas, setRespostasSelecionadas] = useState(
        PERGUNTAS.map(p => ({ id: p.id, valor: p.tipo === 'checkbox' ? [] : "" }))
    );
    const [observacoes, setObservacoes] = useState(evaluationData?.observacoesAnamnese || "");

    useEffect(() => {
        if (evaluationData?.anamnesis) {
            setRespostasSelecionadas(evaluationData.anamnesis);
        }
        if (evaluationData?.observacoesAnamnese !== undefined) {
            setObservacoes(evaluationData.observacoesAnamnese);
        }
    }, [evaluationData]);

    const [selectedAnamnese, setSelectedAnamnese] = useState("anamneseEmagrecimento");
    // FIM

    const handleConfirmTroca = () => {
        // Atualiza o estado no componente pai
        setPerfilAnamnese(selectedAnamnese);
        closeAnamneseTypeModal();
    };

    const atualizarResposta = (perguntaId, novoValor, tipo) => {
        setRespostasSelecionadas(prev => prev.map(item => {
            if (item.id !== perguntaId) return item;

            let valorFinal;
            if (tipo === 'checkbox') {
                const listaAtual = Array.isArray(item.valor) ? item.valor : [];
                valorFinal = listaAtual.includes(novoValor)
                    ? listaAtual.filter(v => v !== novoValor)
                    : [...listaAtual, novoValor];
            } else {
                valorFinal = novoValor;
            }
            return { ...item, valor: valorFinal };
        }));
    };

    const renderPergunta = (id) => {
        const pergunta = PERGUNTAS.find(p => p.id === id);
        if (!pergunta) return null; // Segurança caso o ID não exista

        const rObj = respostasSelecionadas.find(item => item.id === pergunta.id);
        const r = rObj ? rObj.valor : (pergunta.tipo === 'checkbox' ? [] : "");
        const opcoesDaPergunta = OPCOES_RESPOSTAS.find(opt => opt.id === pergunta.id)?.opcoes || [];

        return (
            <div className="question-item" key={pergunta.id}>
                <div className="standard-title">{pergunta.texto}</div>
                
                {pergunta.imagem && (
                    <div className="question-image-container" style={{ textAlign: 'center', margin: '10px 0' }}>
                        <img src={pergunta.imagem} alt="Referência" style={{ maxWidth: '100%', borderRadius: '8px' }} />
                    </div>
                )}

                <div className="answer-container">
                    {/* ... Seus inputs (text, checkbox, radio) continuam exatamente iguais ... */}
                    {pergunta.tipo === 'text' && (
                        <input
                            className="answer-text"
                            value={r}
                            placeholder={pergunta.placeholder}
                            onChange={e => atualizarResposta(pergunta.id, e.target.value, 'text')}
                        />
                    )}
                    {/* Mapeamento das opções e lógica de "Outros" seguem abaixo igual ao seu código original */}
                    {opcoesDaPergunta.map(opcao => (
                        <label className="answer-item" key={opcao}>
                            <input
                                type={pergunta.tipo}
                                className={`answer-${pergunta.tipo}`}
                                checked={pergunta.tipo === 'checkbox' ? r?.includes(opcao) : r === opcao}
                                onChange={() => atualizarResposta(pergunta.id, opcao, pergunta.tipo)}
                            />
                            <p className="answer-title">{opcao}</p>
                        </label>
                    ))}
                    {/* ... (manter bloco do temOutros) ... */}
                </div>
            </div>
        );
    };

    // --- LÓGICA DE DIVISÃO EM COLUNAS ---

    // 1. Filtramos as perguntas da etapa atual
    const perguntasDaEtapa = PERGUNTAS.filter((_, idx) => {
        if (etapa === 1) return idx < 8;
        if (etapa === 2) return idx >= 8 && idx < 16;
        return idx >= 16;
    });

    // 2. Calculamos o ponto médio para dividir as colunas
    const meio = Math.ceil(perguntasDaEtapa.length / 2);
    const perguntasEsquerda = perguntasDaEtapa.slice(0, meio);
    const perguntasDireita = perguntasDaEtapa.slice(meio);

    // Navegação provisória
    // A etapa seguinte depende do perfil do aluno (no idoso, Classificação Funcional).
    const proxima = proximaEtapa(aluno?.profile, 'Anamnese');
    const toAntropometria = () => {
        if (proxima) setActiveTab(proxima.chave);
    };

    const handleAnamnesisRegister = async () => {
        const payload = {
            anamnesis: respostasSelecionadas,
            observacoes,
            evaluationId
        };

        const response = await api.post(`/api/student/${aluno.id}/evaluation/anamnesis`, payload, { withCredentials: true });
        if (response.status === 200) {
            // Se o backend retornou um novo ID (pois acabou de criar no banco), nós atualizamos a página pai!
            if (response.data.evaluationId && setEvaluationId) {
                setEvaluationId(response.data.evaluationId);
            }
            if (updateEvaluationData) {
                updateEvaluationData({ anamnesis: respostasSelecionadas, observacoesAnamnese: observacoes });
            }
            openNextModal();
        }
    };

    return (
        <div className="avaliacao-container">
            <div className="avaliacao-content">
                {etapa === 1 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[0, 1, 2].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[3, 4].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 2 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[5, 6, 7].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[8, 9, 10].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 3 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[11, 12, 13].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[14, 15, 16].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 4 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[17, 18].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                        </div>
                    </div>
                )}

                <Modal
                    isOpen={isAnamneseTypeModal}
                    onRequestClose={closeAnamneseTypeModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    {isChoosingAnamnese ? (
                        <>
                            <p className="anamnese-modal-type-p">Selecione o tipo de anamnese:</p>
                            <select 
                                className="select-anamnese"
                                value={selectedAnamnese}
                                onChange={(e) => setSelectedAnamnese(e.target.value)}
                            >
                                <option value="anamneseAdultos">Adultos</option>
                                <option value="anamneseEmagrecimento">Mulheres emagrecimento</option>
                                <option value="anamneseIdosos">Idosos</option>
                                <option value="anamneseGestantes">Gestantes</option>
                                <option value="anamnesePosParto">Pós Parto</option>
                                <option value="anamneseObesos">Obesos</option>
                                <option value="anamneseDiabetes">Diabetes</option>
                                <option value="anamneseHipertensao">Hipertensão</option>
                                <option value="anamneseDepressao">Depressao</option>
                            </select>
                            <div>
                                <button className="next-prev-button" onClick={handleConfirmTroca}>
                                    Confirmar Troca
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <p className="anamnese-modal-type-p">
                                De acordo com o perfil do avaliado, recomenda-se<br />
                                anamnese para <span className="anamnese-modal-type-profile">Adultos</span>. Deseja
                                continuar <br /> ou escolher outra anamnese?
                            </p>
                            <div className="sub-pagination-buttons">
                                <button className="next-prev-button" type="button" onClick={closeAnamneseTypeModal}>
                                    Continuar
                                </button>
                                <button className="next-prev-button" type="button" onClick={handleChooseAnamnese}>
                                    Trocar Anamnese
                                </button>
                            </div>
                        </>
                    )}
                </Modal>

                <Modal
                    isOpen={isNextModal}
                    onRequestClose={closeNextModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    <p className="popupNext-h1">Anamnese finalizada!</p>
                    <p className="popupNext-h2">{textoProximaEtapa(proxima)}</p>
                    <div className="sub-pagination-buttons">
                        <button className="next-prev-button" type="button" onClick={toAntropometria}>
                            Sim
                        </button>
                        <button className="next-prev-button" type="button" onClick={closeNextModal}>
                            Não
                        </button>
                    </div>
                </Modal>

                {etapa === totalEtapas && (
                    <div className="anamnese-observacoes">
                        <div className="standard-title">Observações</div>
                        <textarea
                            className="anamnese-observacoes-input"
                            placeholder="Escreva observações adicionais sobre o avaliado..."
                            value={observacoes}
                            onChange={(e) => setObservacoes(e.target.value)}
                        />
                    </div>
                )}

                <div className="pagination-footer">
                    <div className="sub-pagination-footer">
                        <div className="sub-pagination-buttons">
                            {etapa > 0 && (
                                <button className="next-prev-button" type="button" onClick={retrocederEtapa}>
                                    Voltar
                                </button>
                            )}
                            {etapa < 4 ? (
                                <button className="next-prev-button" type="button" onClick={avancarEtapa}>
                                    Avançar
                                </button>
                            ) : (
                                <button className="next-prev-button" type="button" onClick={handleAnamnesisRegister}>Registrar</button>
                            )}
                        </div>
                        <div className="progress-container">
                            <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
                        </div>
                    </div>
                    <div className="info-box-container" >
                        <div className="info-button" onClick={openAnamneseTypeModal}>
                            Trocar Anamnese
                        </div>
                        <div className="info-button" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
                            <HelpCircle size={20} />
                            Mais informações
                        </div>
                        {showInfo && (
                            <div className="info-box-content">
                                <p className="">A anamnese é a primeira etapa de uma avaliação física e consiste em uma entrevista estruturada entre o profissional
                                    de Educação Física e o avaliado. Seu objetivo é coletar informações detalhadas sobre o histórico de saúde, estilo de vida, hábitos e
                                    objetivos do indivíduo, servindo como base para um planejamento seguro e personalizado do programa de treinamento.
                                </p>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AnamneseMulheresEmagrecimento;